/* Gift-promo cart nudge — claim button handler.
   One delegated listener, bound once, survives every drawer/cart re-render
   (Dawn replaces the nudge's DOM on each cart change; a script tag inserted
   via innerHTML never executes, so binding to the button itself would die on
   the first re-render — delegation is load-bearing here).

   CLAIM = READ-THEN-ADD-THE-DIFFERENCE, never an absolute set. Empirical
   finding (2026-07-25): when both box discounts apply, Shopify SPLITS the
   free-pack variant into multiple cart lines, and a variant-keyed
   /cart/update.js only touches the FIRST matching line — an absolute set
   against a split cart overshoots and makes the customer PAY for packs the
   button called free. So: fetch the cart, sum every line of the reward
   variant, add only (target - current) via /cart/add.js. The button disables
   synchronously on click, so a double-click cannot add the difference twice. */
(function () {
  'use strict';
  if (window.__lscGiftNudge) return;
  window.__lscGiftNudge = true;

  function sectionInner(data, key, id) {
    if (!data || !data[key]) return null;
    return new DOMParser().parseFromString(data[key], 'text/html').getElementById(id);
  }

  function refreshSurfaces() {
    /* Cart page: Dawn's own component refetches main-cart-items (nudge included). */
    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.onCartUpdate === 'function') cartItems.onCartUpdate();

    /* Drawer + header bubble: the same section fetch Dawn uses after add. */
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var drawer = document.getElementById('CartDrawer');
        var freshDrawer = sectionInner(data, 'cart-drawer', 'CartDrawer');
        if (drawer && freshDrawer) drawer.innerHTML = freshDrawer.innerHTML;

        var bubble = document.getElementById('cart-icon-bubble');
        var freshBubble = sectionInner(data, 'cart-icon-bubble', 'cart-icon-bubble');
        if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
      });
  }

  /* Opt-in button (member gate): subscribes the logged-in customer's email to
     marketing via the native storefront customer form — no app involved. The
     segment that unlocks the discount refreshes on Shopify's side (typically
     under a couple of minutes), so the confirmation copy manages expectation
     instead of promising instant $0.00. */
  document.addEventListener('click', function (e) {
    var sub = e.target && e.target.closest && e.target.closest('[data-gift-nudge-subscribe]');
    if (!sub) return;
    e.preventDefault();
    if (sub.getAttribute('aria-disabled') === 'true') return;
    sub.setAttribute('aria-disabled', 'true');

    var body = new URLSearchParams();
    body.set('form_type', 'customer');
    body.set('utf8', '✓');
    body.set('contact[email]', sub.dataset.giftEmail || '');
    body.set('contact[tags]', 'newsletter');

    fetch('/contact', { method: 'POST', body: body })
      .then(function (r) {
        if (r.status >= 500) throw new Error('subscribe ' + r.status);
        var wrap = sub.closest('[data-gift-nudge]');
        if (wrap) {
          wrap.innerHTML =
            '<span class="gift-nudge__check" aria-hidden="true">&#10003;</span>' +
            '<p class="gift-nudge__text"><strong>You’re on the list!</strong> ' +
            'Your free packs unlock in a minute or two — add them and the ' +
            'discount applies at checkout. (Check your inbox if we ask you to confirm.)</p>';
          wrap.classList.add('gift-nudge--done');
        }
      })
      .catch(function () {
        sub.removeAttribute('aria-disabled');
      });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-gift-nudge-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');

    var variantId = parseInt(btn.dataset.giftVariant, 10);
    var target = parseInt(btn.dataset.giftTarget, 10);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart.js')
      .then(function (r) { if (!r.ok) throw new Error('cart read ' + r.status); return r.json(); })
      .then(function (cart) {
        var current = 0;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === variantId) current += cart.items[i].quantity;
        }
        var diff = target - current;
        if (diff <= 0) return null; /* already satisfied — just refresh the UI */
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: diff })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart add ' + r.status);
          return r.json();
        });
      })
      .then(refreshSurfaces)
      .catch(function () {
        /* leave the cart untouched and re-arm the button */
        btn.removeAttribute('aria-disabled');
      });
  });
})();
